import { render, staticRenderFns } from "./ProposalCardOverlay.vue?vue&type=template&id=5ec73212&"
import script from "./ProposalCardOverlay.vue?vue&type=script&lang=js&"
export * from "./ProposalCardOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ProposalCardOverlay.vue?vue&type=style&index=0&id=5ec73212&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports